import * as React from "react";

import styles from "./Toggle.module.css";

export interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: React.ReactNode;
  disabled?: boolean;
  className?: string;
}

/** iOS-style switch (e.g. "Авторский надзор"). */
export const Toggle: React.FC<ToggleProps> = ({ checked, onChange, label, disabled, className }) => (
  <span
    className={`${styles.root}${disabled ? ` ${styles.disabled}` : ``}${className ? ` ${className}` : ``}`}
    onClick={() => !disabled && onChange(!checked)}
  >
    {label && <span className={styles.label}>{label}</span>}
    <span className={`${styles.track}${checked ? ` ${styles.on}` : ``}`}>
      <span className={styles.knob} />
    </span>
  </span>
);
